<template>
    <div>
      <!-- Скелетон таблицы -->
      <b-card class="mb-4" v-if="showTable">
        <b-table-simple bordered>
          <b-thead>
            <b-tr>
              <b-th v-for="col in cols" :key="'th-' + col">
                <b-skeleton :width="headerSkeletonWidth" height="20px"></b-skeleton>
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="row in rows" :key="'tr-' + row">
              <b-td v-for="col in cols" :key="'td-' + row + '-' + col">
                <b-skeleton width="100%" height="20px"></b-skeleton>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card>
  
      <!-- Скелетон под график -->
      <b-card v-if="showChart">
        <b-skeleton :height="chartHeight" width="100%"></b-skeleton>
      </b-card>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SkeletonLoader',
    props: {
      showChart: {
        type: Boolean,
        default: true
      },
      showTable: {
        type: Boolean,
        default: true
      },
      cols: {
        type: Number,
        default: 4
      },
      rows: {
        type: Number,
        default: 6
      },
      chartHeight: {
        type: String,
        default: '300px'
      },
      headerSkeletonWidth: {
        type: String,
        default: '80px'
      }
    }
  }
  </script>  